import React from "react";
import "../workexperience/workExperience.css";
import InquiryForm from "../InquiryForm";

const WorkExperienceCanada = () => {
  return (
    <div className="work-experience-container">

      {/* HERO SECTION */}
      <section className="hero-section">
        <div className="hero-text">
          <h1>International Work Experience in Canada</h1>
          <p>
            Embark on a transformative professional journey in Canada, one of the world's most 
            welcoming and prosperous nations. With its thriving economy, multicultural environment, 
            and excellent work-life balance, Canada offers unparalleled opportunities for international 
            professionals to grow and succeed.
          </p>
        </div>

        <div className="hero-image">
          <img
            src="https://images.unsplash.com/photo-1517935706615-2717063c2225?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80"
            alt="Work in Canada - Toronto Skyline"
          />
        </div>
      </section>

      {/* DEFINITION SECTION */}
      <section className="definition-section">
        <h2>What is Work Experience?</h2>
        <p>
          Simply put, it is an opportunity that employers offer to candidates interested in gaining 
          work experience in particular industries. With this primer, learn more about what experience 
          are and why candidate benefit from them. Work experience offers Candidate hands-on opportunity 
          to work in their desired field. They learn how their course of study applies to the real world 
          and build a valuable experience that makes them stronger candidates for jobs after graduation.
        </p>
        <p>
          Experience can be an excellent way to "try out" a certain career. For instance, you may think 
          you want a fast-paced job in advertising after college, but after an internship, you may find 
          that it's not for you; that's valuable insight that will help you choose your career path.
        </p>
      </section>

      {/* HIGHLIGHTS SECTION */}
      <section className="highlights-section">
        <h2>Why Choose Canada?</h2>
        <div className="highlights-grid">
          <div className="highlight-card">
            <h3>🌍 Global Experience</h3>
            <p>Opportunity to work in one of the most developed countries in the world with a strong economy and excellent career prospects.</p>
          </div>

          <div className="highlight-card">
            <h3>🚀 Early Career Boost</h3>
            <p>Get an opportunity to work at international level right at the beginning of your career.</p>
          </div>

          <div className="highlight-card">
            <h3>👥 Senior Guidance</h3>
            <p>Get real work experience under the guidance of experienced seniors and industry experts.</p>
          </div>

          <div className="highlight-card">
            <h3>📚 Skill Development</h3>
            <p>It helps to improve your skills and knowledge through hands-on experience in a global workplace.</p>
          </div>

          <div className="highlight-card">
            <h3>💰 Financial Benefits</h3>
            <p>You also get monthly salary / stipend for what you work, ensuring financial independence.</p>
          </div>

          <div className="highlight-card">
            <h3>⚡ Career Readiness</h3>
            <p>It makes you ready to face challenges in this competitive global market.</p>
          </div>

          <div className="highlight-card">
            <h3>🎯 For All Levels</h3>
            <p>Helpful for fresher and even for experienced professionals looking to enhance their career.</p>
          </div>

          <div className="highlight-card">
            <h3>🌐 Global Network</h3>
            <p>Help to work at international level in future and build a strong professional network.</p>
          </div>

          <div className="highlight-card">
            <h3>💪 Confidence Building</h3>
            <p>It improves your confidence by exposing you to diverse work environments and challenges.</p>
          </div>

          <div className="highlight-card">
            <h3>📄 Strong Resume</h3>
            <p>It makes your resume strong with valuable international work experience.</p>
          </div>
        </div>
      </section>

      {/* BENEFITS SECTION */}
      <section className="benefits-section">
        <h2>Key Benefits</h2>
        <ul className="benefits-list">
          <li>Work in a diverse and inclusive environment</li>
          <li>Access to world-class healthcare and social benefits</li>
          <li>Pathway to permanent residency</li>
          <li>Competitive salary packages</li>
          <li>Excellent work-life balance</li>
          <li>Multicultural work environment</li>
          <li>Professional development opportunities</li>
          <li>Networking with global professionals</li>
        </ul>
      </section>

      {/* OPPORTUNITIES SECTION */}
      <section className="opportunities-section">
        <h2>Work Opportunities</h2>
        <div className="opportunity-grid">
          <div className="opportunity-item">
            <h3>💻 IT & Technology</h3>
            <p>Toronto, Vancouver, Montreal - Tech hubs with numerous opportunities</p>
          </div>
          <div className="opportunity-item">
            <h3>🏥 Healthcare</h3>
            <p>High demand for healthcare professionals across all provinces</p>
          </div>
          <div className="opportunity-item">
            <h3>🏗️ Engineering</h3>
            <p>Civil, mechanical, and software engineering opportunities</p>
          </div>
          <div className="opportunity-item">
            <h3>💰 Finance</h3>
            <p>Banking and financial services in Toronto's Bay Street</p>
          </div>
        </div>
      </section>

      {/* COUNTRIES SECTION */}
      <section className="countries-section">
        <h2>Major Work Destinations</h2>
        <div className="countries-list">
          <span className="country-tag">🇨🇦 Toronto</span>
          <span className="country-tag">🇨🇦 Vancouver</span>
          <span className="country-tag">🇨🇦 Montreal</span>
          <span className="country-tag">🇨🇦 Calgary</span>
          <span className="country-tag">🇨🇦 Ottawa</span>
          <span className="country-tag">🇨🇦 Quebec City</span>
        </div>
      </section>

      {/* INQUIRY FORM */}
      <InquiryForm title="Inquire About Work Experience in Canada" />

    </div>
  );
};

export default WorkExperienceCanada;